module.exports = __webpack_public_path__ + "media/video.3b19742f.webm";